module.exports = __webpack_public_path__ + "img/twitter.426e9e6b.svg";